export enum PuzzleRoundStatusEnum {
  IDLE,
  STARTED,
  WON,
  LOST,
}

export type PuzzleRoundType = {
  id: string;
  allTimePoints: number;
  initialPuzzleSlicesCompleted: number;
  brandName: string;
  brandDescription: string;
  brandShortDescription: string;
  title: string;
  logoUrl: string;
  puzzleImage: string;
  puzzleOriginalImageWidth: number;
  puzzleOriginalImageHeight: number;
  cpl: PuzzleCplType;
  slicesPerRow: number;
  totalRows: number;
  totalSlices: number;
  pendingSlices: (number | null)[];
  arrangedSlices: (number | null)[];
  scaleFactor: number;
  roundIndex: number;
};

export type PuzzleCplType = {
  name: string | null;
  title: string | null;
  formPath: string | null;
  tacPath: string | null;
  brandName: string | null;
  description: string | null;
  imageUrl: string | null;
  isAccepted?: boolean | null;
  isTacAccepted?: boolean;
  bid: number | null;
};

export type PuzzleLoadedImage = {
  puzzleImage: string;
  puzzleOriginalImageWidth: number;
  puzzleOriginalImageHeight: number;
};

declare global {
  interface FKL {
    puzzleSlug: string;
  }
}
